export default __webpack_public_path__ + "static/media/celular-tvs.c804c84d.png";